import { useMemo } from 'react';

import { dayjs } from '../../Components/Dayjs/dayjs-utils';
import useGetLastSeenLocation from './useGetLastSeenLocation';
import useGetLastSeenText from './useGetLastSeenText';

interface IUseGetLastSeenOtherUserProps {
    areaName: string | undefined;
    hasLocation?: boolean;
    layerName: string | undefined;
    timestamp: string | undefined;
}

export default function useGetLastSeenOtherUser({
    areaName,
    hasLocation = true,
    layerName,
    timestamp,
}: Readonly<IUseGetLastSeenOtherUserProps>) {
    const lastSeenMinutes = useMemo(() => {
        if (timestamp) {
            const now = dayjs();
            const lastSeen = dayjs(timestamp);
            const duration = dayjs.duration(now.diff(lastSeen));
            return duration.asMinutes();
        } else {
            return null;
        }
    }, [timestamp]);

    const lastSeenLocation = useGetLastSeenLocation({
        area: areaName,
        layer: layerName,
    });
    const lastSeenTime = useGetLastSeenText({ lastSeenMinutes, timestamp: timestamp });

    // Show location only if last activity was less than 10 minutes ago and location exists
    // Otherwise show the time
    const lastSeenText =
        hasLocation && lastSeenMinutes !== null && lastSeenMinutes <= 10
            ? lastSeenLocation || lastSeenTime
            : lastSeenTime;

    return { lastSeenMinutes, lastSeenText };
}
